import _slicedToArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { useContext, useEffect } from "react";
import { AppExperimentContext } from "@catchoftheday/analytics";
import { cookies } from "@catchoftheday/utilities";
import { AUTH_FLOW_TOGGLE_COOKIE_NAME, AUTH_TOKEN_EXPIRY_COOKIE_NAME, LOGIN_ENDPOINT } from "../../consts";
export var MAX_RE_AUTH_RETRIES = 3;
export var RE_AUTH_RETRY_COOKIE_NAME = "RE_AUTH_RETRY_COUNT";

var reAuthenticateConditionally = function reAuthenticateConditionally(_ref) {
  var isLoggedInOnOldFlow = _ref.isLoggedInOnOldFlow,
      isInNewAuthFlow = _ref.isInNewAuthFlow;
  var hasAuthCookie = !!cookies.get(AUTH_TOKEN_EXPIRY_COOKIE_NAME);
  var reAuthRetryCount = Number(cookies.get(RE_AUTH_RETRY_COOKIE_NAME) || "0");

  if (false || !isLoggedInOnOldFlow || !isInNewAuthFlow || hasAuthCookie || reAuthRetryCount > MAX_RE_AUTH_RETRIES) {
    // If skipping, reset re-auth retry count
    cookies.remove(RE_AUTH_RETRY_COOKIE_NAME);
    return;
  }

  cookies.set(RE_AUTH_RETRY_COOKIE_NAME, (reAuthRetryCount + 1).toString());
  window.location.assign("".concat(LOGIN_ENDPOINT, "?returnTo=").concat(encodeURIComponent(window.location.href)));
};

export var useInitAuthFlow = function useInitAuthFlow(_ref2) {
  var isLoggedInOnOldFlow = _ref2.isLoggedInOnOldFlow;

  var _useContext = useContext(AppExperimentContext),
      getExperiments = _useContext.getExperiments;

  var _getExperiments = getExperiments(["new_auth_flow_may_24"]),
      _getExperiments$exper = _slicedToArray(_getExperiments.experiments, 1),
      experiment = _getExperiments$exper[0],
      experimentsLoading = _getExperiments.loading;

  useEffect(function () {
    if (experimentsLoading || !experiment) {
      return;
    }

    var isInNewAuthFlow = experiment.bucket === 1;
    cookies.set(AUTH_FLOW_TOGGLE_COOKIE_NAME, isInNewAuthFlow ? "1" : "0");
    reAuthenticateConditionally({
      isLoggedInOnOldFlow: isLoggedInOnOldFlow,
      isInNewAuthFlow: isInNewAuthFlow
    });
  }, [experiment, experimentsLoading, isLoggedInOnOldFlow]);
  return null;
};